module.exports = __webpack_public_path__ + "static/img/course2.e7f99fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course2.png
// module id = kSWA
// module chunks = 63